import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('website_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setSubmitStatus('success');
      setEmail('');
      return;
    }
    try {
      const res = await fetch('https://readdy.ai/api/form/d95mf4bjjt5fme3c4vug', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const text = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(text); } catch { /* ignore parse errors */ }
      if (res.ok && parsed?.code === 'OK') {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
        setErrorMsg(parsed?.meta?.message || parsed?.message || '订阅失败，请稍后再试');
      }
    } catch (_err) {
      setSubmitStatus('error');
      setErrorMsg('网络错误，请检查网络后重试');
    }
  };

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          {/* Left: Brand + Subscribe */}
          <div className="lg:w-2/5">
            <Link to="/" className="flex items-center gap-2 mb-6 cursor-pointer">
              <span className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-fire-line text-background-50 text-xl"></i>
              </span>
              <span className="font-heading font-bold text-xl text-background-50">
                51吃瓜爆料网
              </span>
            </Link>
            <p className="text-background-400 text-sm leading-relaxed mb-8 max-w-md">
              做最真实的娱乐八卦，让每一口瓜都有据可查。
              <br />
              每日更新热门大瓜，明星塌房、网红翻车、综艺深扒，一网打尽。
            </p>

            {/* Newsletter */}
            <div>
              <p className="text-background-300 text-sm mb-3">订阅每日吃瓜速报</p>
              <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-2" data-readdy-form="">
                <div className="relative flex-1">
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="输入你的邮箱"
                    required
                    className="w-full bg-transparent border-b border-background-600 py-2.5 px-0 text-background-200 text-sm outline-none focus:border-primary-400 transition-colors placeholder:text-background-500"
                  />
                </div>
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="website_alt_field"
                />
                <button
                  type="submit"
                  className="px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  订阅
                </button>
              </form>
              {submitStatus === 'success' && (
                <p className="text-accent-400 text-xs mt-2">订阅成功！每日最新大瓜将发送到你的邮箱。</p>
              )}
              {submitStatus === 'error' && (
                <p className="text-primary-400 text-xs mt-2">{errorMsg}</p>
              )}
            </div>
          </div>

          {/* Right: Links */}
          <div className="lg:w-3/5 grid grid-cols-3 gap-8">
            <div>
              <h4 className="text-background-100 font-heading font-semibold text-sm mb-4">
                <a href="/about" className="hover:text-background-50 transition-colors">品牌简介</a>
              </h4>
              <ul className="space-y-2.5">
                <li><Link to="/about" className="text-background-400 text-sm hover:text-background-200 transition-colors cursor-pointer">关于我们</Link></li>
                <li><a href="/about" className="text-background-400 text-sm hover:text-background-200 transition-colors">投稿须知</a></li>
                <li><a href="/about" className="text-background-400 text-sm hover:text-background-200 transition-colors">免责声明</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-background-100 font-heading font-semibold text-sm mb-4">
                <a href="/about" className="hover:text-background-50 transition-colors">合作联系</a>
              </h4>
              <ul className="space-y-2.5">
                <li><a href="/about" className="text-background-400 text-sm hover:text-background-200 transition-colors">商务合作</a></li>
                <li><a href="/about" className="text-background-400 text-sm hover:text-background-200 transition-colors">侵权申诉</a></li>
                <li><a href="/about" className="text-background-400 text-sm hover:text-background-200 transition-colors">加入我们</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-background-100 font-heading font-semibold text-sm mb-4">
                <a href="#hot" className="hover:text-background-50 transition-colors">热门分类</a>
              </h4>
              <ul className="space-y-2.5">
                <li><Link to="/category/star-collapse" className="text-background-400 text-sm hover:text-background-200 transition-colors cursor-pointer">明星塌房</Link></li>
                <li><Link to="/category/influencer-fail" className="text-background-400 text-sm hover:text-background-200 transition-colors cursor-pointer">网红翻车</Link></li>
                <li><Link to="/category/variety-deep" className="text-background-400 text-sm hover:text-background-200 transition-colors cursor-pointer">综艺深扒</Link></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-6 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-500 text-xs">
            &copy; 2026 51吃瓜爆料网 版权所有 | 吃瓜无罪，八卦有理
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-background-300 transition-colors text-xs" rel="nofollow">隐私政策</a>
            <a href="#" className="text-background-500 hover:text-background-300 transition-colors text-xs" rel="nofollow">用户协议</a>
          </div>
        </div>
      </div>
    </footer>
  );
}